import { Paper, FormControlLabel } from '@mui/material';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';

const RegistrationChildNotes = ({ updateChild }) => {
  const handleFormChange = e => {
    updateChild(e.target);
  };

  return (
    <Paper elevation={5} sx={{ padding: '20px' }}>
      <p>Does your child have a special need we should be aware of?</p>
      <TextField
        fullWidth
        select
        margin='dense'
        name='notes'
        onChange={handleFormChange}
        id='child-notes'
        defaultValue={'no'}
        helperText='If Yes, our catechetical coordinator will be in touch with you to gather more details which would help us catechise your child in a safe and conducive environment.'
      >
        <MenuItem value='no'>NO</MenuItem>
        <MenuItem value='yes'>YES</MenuItem>
      </TextField>

      <div className='spacer'></div>

      <div>
        <p className='pb-3'>
          By enrolling my child in OLPS Catechetical Sessions, I acknowledge and
          consent to the taking of photos and videos of my child/ward from time
          to time during weekly sessions including (but not limited to) Outreach
          days, Workshops, gatherings etc, for the purposes of:
        </p>
        <ol className='list-inside list-decimal'>
          <li>Advocating and promoting the Church's cause/initiatives;</li>
          <li>Catechetical Office archives for future reference.</li>
        </ol>
        <p className='pt-3'></p>
        <FormControlLabel
          control={
            <Checkbox
              id='cb3'
              defaultChecked
              value='YES'
              name='photo_opt_in'
              inputProps={{ 'data-cy': 'cb3' }}
              onChange={handleFormChange}
            />
          }
          label='I acknowledge that such photographs and/or videos may be published
            on OLPS websites, publications and social media.'
        />
        <div className='spacer'></div>
        <div className='text-sm text-gray-600'>
          NOTE: If you wish to withdraw consent in any event, please approach
          the persons-in-charge of the event or write in to our Catechetical
          Office. You may wish to visit our website: www.olps.sg/pdpa for our
          Privacy Statement and the Digital Protection Officer (DPO) contact
          details.
        </div>
      </div>
    </Paper>
  );
};

export default RegistrationChildNotes;
